(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
  const mountCartDrawer = () => {
    const drawer = document.querySelector('m-cart-drawer.m-cart-drawer');

    if (!drawer || !document.body) return;

    if (drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }

    drawer.style.setProperty('--cart-drawer-top', '0px');
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountCartDrawer, { once: true });
  } else {
    mountCartDrawer();
  }

  document.addEventListener('shopify:section:load', mountCartDrawer);
})();
  } catch(e) { console.error(e); }
})();

})();
